import Loader from './Loader';

export default Loader;

export { Loader };
